export type CoverImage = { src: string; srcSet?: string };
export const COVER_WIDTHS = [480, 640, 960, 1400] as const;
export const PHOTO_COVER_WIDTHS = [480, 960] as const;
export const COVER_IMAGE_QUALITY = 75;
// max-width 1400; page insets 20/32; grid gap 32; 1/2/3 columns.
export const PHOTO_CARD_SIZES = "(min-width: 1400px) 424px, (min-width: 1024px) calc((100vw - 128px) / 3), (min-width: 640px) calc((100vw - 72px) / 2), calc(100vw - 40px)";
export const CONTAINED_HERO_SIZES = "(min-width: 1400px) 1336px, (min-width: 1024px) calc(100vw - 64px), calc(100vw - 40px)";